import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppConfiguration } from '@schemas/app.interface';
import { Hit, StoreMediaEntity } from '../../../components/search/search-response.interface';
import { ActivatedRoute, Params } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ScreenDetectorBootstrapService } from '@services/app/screen-detector-bootstrap.service';

@Component({
  selector: 'tvb-product-card-elk',
  templateUrl: './product-card-elk.component.html',
  styleUrls: ['./product-card-elk.component.scss'],
})
export class ProductCardElkComponent implements OnInit {
  @Input() product: Hit;
  @Input() appConfig: AppConfiguration;
  @Input() saleBadge: boolean = true;
  @Input() theme: string = 'default';
  @Input() isImageLazyLoaded?: boolean = true;
  @Output() outputCall: EventEmitter<unknown> = new EventEmitter();
  isMobile$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  routePathParams: Params;
  originalUrl: string = '';
  imageUrl: string = '';
  displayedMediaEntity: StoreMediaEntity[] = [];

  constructor(private activatedRoute: ActivatedRoute, private screenSizeDetector: ScreenDetectorBootstrapService) {}

  ngOnInit(): void {
    this.isMobile$ = this.screenSizeDetector.isMobile;
    this.setDisplayedMediaEntity();
    this.setImageUrl();
    this.setOriginalUrl();
    this.routePathParams = this.activatedRoute.snapshot.params;
    this.appConfig.currencyCode ||= 'EUR';
  }

  setDisplayedMediaEntity() {
    this.displayedMediaEntity = this.product?.mediaEntities.filter(
      media => media.deleted === false && media.displayOrder === '0'
    );
  }

  setImageUrl() {
    if (this.product?.mediaEntities && this.product?.mediaEntities.length > 0) {
      if (this.isMobile$.value) {
        this.imageUrl
          = this.displayedMediaEntity.length > 0
            ? this.displayedMediaEntity[0].compactUrl
            : this.product?.mediaEntities[0]?.compactUrl;
      }
      else {
        this.imageUrl
          = this.displayedMediaEntity.length > 0
            ? this.displayedMediaEntity[0]?.mediumUrl
            : this.product?.mediaEntities[0]?.mediumUrl;
      }
    }
  }

  setOriginalUrl() {
    if (this.product?.mediaEntities && this.product?.mediaEntities.length > 0) {
      this.originalUrl
        = this.displayedMediaEntity.length > 0
          ? this.displayedMediaEntity[0]?.originalUrl
          : this.product?.mediaEntities[0]?.originalUrl;
    }
  }

  shouldShowSizeInfo(): boolean {
    if (
      this.routePathParams['parent_category_seo_url'] === 'jewelry'
      || this.routePathParams['parent_category_seo_url'] === 'bags'
      || this.routePathParams['parent_category_seo_url'] === 'accessories'
    )
      return false;

    return !!this.product.bagsSize || !!this.product.clothingSize || !!this.product.shoesSize;
  }

  // isWeLove() {
  //   return this.product?.discover?.find(x => x === 'we-love');
  // }

  callBack() {
    this.outputCall.emit(true);
  }
}
